<emp-mobile-solutions-menu />

<a routerLink="/account">
  <span class="material-symbols-rounded-m">person</span>
  <span>{{ 'MY_PROFILE' | translate }}</span>
</a>

<button class="reset log-out-btn" (click)="authService.logout()">
  <span class="material-symbols-rounded-m">logout</span>
  <span>{{ 'LOG_OUT' | translate }}</span>
</button>

<div class="languages-menu">
  @for (language of languages; track language) {
    <button class="reset" (click)="changeLanguage(language)" [class.selected]="language === languageService.language()">
      {{ language | uppercase }}
    </button>
  }
</div>
